import { render, staticRenderFns } from "./PmdaRelativePopup.vue?vue&type=template&id=756f26b8&"
import script from "./PmdaRelativePopup.vue?vue&type=script&lang=js&"
export * from "./PmdaRelativePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports